<template>
<div v-loading="isLoading">
  <!-- header -->
  <div v-if="!isTagList">
    <el-row class="btn-top-area">
      <el-col :span="12">
        <el-button size="small" @click="changeKedbListView">목록보기</el-button>
        <el-button icon="fas fa-edit" v-if="isAdmin" size="small" @click="editKedbInfo"></el-button>
      </el-col>
      <el-col :span="12">
        <div class="align-right">
          <el-button icon="fas fa-caret-left" size="small" v-show="showPrevBtn" @click="clickPrevButton"></el-button>
          <el-button icon="fas fa-caret-right" size="small" v-show="showNextBtn" @click="clickNextButton"></el-button>
        </div>
      </el-col>
    </el-row>
  </div>
  <el-row class="mr-b25">
    <el-col :span="24">
      <table class="list-another02">
        <tfoot>
          <tr>
            <th><span class="txt-space">작성자</span>{{kedbInfo.writerId}}</th>
            <td>
              <el-button type="secondary" @click="clickThumbsUpBtn"><span class="fas fa-thumbs-up mr-r4"></span>{{kedbInfo.recommendCount}}</el-button>
            </td>
          </tr>
        </tfoot>
        <tr>
          <th>
            <span class="de-list">[#{{kedbInfo.seqNumber}}]  {{kedbInfo.title}}</span>
          </th>
          <td>
            <span class="txt-space">{{getDateFormatter(kedbInfo.writeDatetime)}}</span>
          </td>
        </tr>
      </table>
    </el-col>
  </el-row>
  <!-- content -->
  <el-row class="mr-b25">
    <el-collapse class="square-icon mr-b15" v-model="kedbDetailCollapse">
      <el-collapse-item title="장애 증상" name="errSymptomView">
        <div class="quill-editor kedb">
          <div class="ql-container">
            <div class="ql-editor" v-html="errorSymptomRaw"/>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="조치 방법" name="errSolutionView">
        <div class="quill-editor kedb">
          <div class="ql-container">
            <div class="ql-editor" v-html="errorSolutionRaw"/>
          </div>
        </div>
        <div v-if="kedbAttachInfo.length > 0" v-for="item in kedbAttachInfo" :key="item.attachFileUrl">
          <i class="far fa-file-download" style="margin-right: 2px;"></i>
          <span class="link c-pointer" @click="downloadAttachFile(item)">{{ item.attachFilename }}.{{ item.attachFiletype }}&nbsp; &nbsp;</span>
          <span>{{ item.managerId }}&nbsp;({{ getDateFormatter(item.registDatetime) }})</span>
        </div>
      </el-collapse-item>
      <el-collapse-item title="연결된 장애티켓" name="relationRscView">
        <el-table-wrapper class="mr-t10" ref="relationTroubleTable" :data="relationTroubleList" :columns="relationTroubleColumns"
         :show-custom-header="false" :show-search-tool="false" style="width:100%;" :pagination="false" :column-default="columnDefault">
         <template slot-scope="scope" slot="trouble-ticket-group-id-slot">
           <span class="link c-pointer" @click="clickTroubleTicketGroupId(scope.row.troubleTicketGroupId)">{{scope.row.subject}}</span>
         </template>
        </el-table-wrapper>
      </el-collapse-item>
    </el-collapse>
    <div v-if="kedbRscInfo.length > 0">
      <div v-if="isTagList">
        <el-tag class="mr-r4" v-for="item in kedbRscInfo" :key="item.rscInfoKey">{{item.label}}</el-tag>
      </div>
      <div v-else>
        <el-tag class="c-pointer mr-r4" v-for="item in kedbRscInfo" :key="item.rscInfoKey" @click.native="applyKedbFilter(item)">{{item.label}}</el-tag>
      </div>
    </div>
  </el-row>
  <w-event-ticket-status-popup ref="statusPop" :isReadOnlyTicket="true" :trouble-ticket-info="troubleTicketInfo"></w-event-ticket-status-popup>
  <w-kedb-add-popup v-if="isAdmin" ref="kedbEditPopup" popupType="UPDATE" :kedbDetailInfo="settingInfo" @reload="loadData"></w-kedb-add-popup>
</div>
</template>

<script>
import KedbAPI from '@/api/event/kedb';
import { isNil, isEmpty, clone, has } from 'lodash';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import { mapGetters } from 'vuex';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import WKedbAddPopup from './popup/KedbAddPopup';

export default {
  name: 'WKedbDetailView',
  components: {
    WEventTicketStatusPopup: () => import('@/views/event/components/popup/EventTicketStatusPopup'),
    WKedbAddPopup,
  },
  props: {
    /**
     * KEDB 상세 정보 조회 파라미터
     * KEDB 목록에서 조회된 경우 목록의 조건 파라미터를 가지며,
     * 그 외의 경우는 seqNumber만 필드로 가진다.
     * @type {Object}
     */
    params: {
      type: Object,
    },
    viewType: {
      type: String,
    },
  },
  data() {
    return {
      /**
       * KEDB 상세 조회 seqNumber
       * @type {Number}
       */
      kedbSeqNumber: null,
      /**
       * KEDB 목록 조건 파라미터
       * @type {Object}
       */
      kedbTableParams: null,
      columnDefault,
      isLoading: false,
      kedbDetailCollapse: ['errSymptomView', 'errSolutionView', 'relationRscView'],
      settingInfo: {},
      errorSymptomRaw: '',
      errorSolutionRaw: '',
      kedbInfo: {
        writerId: '',
        title: '',
        seqNumber: null,
        writeDatetime: null,
        recommendCount: null,
      },
      kedbAttachInfo: [],
      kedbRscInfo: [],
      relationTroubleList: [],
      shootingHistData: [],
      troubleTicketInfo: {
        troubleTicketGroupId: null,
      },
      troubleTicketGroupInfoList: [],
      relationTroubleColumns: [
        { prop: 'troubleTicketGroupId', width: '55', label: 'No', sortable: true },
        { prop: 'subject', scopedSlot: 'trouble-ticket-group-id-slot', label: '장애티켓 제목', sortable: true },
      ],
    };
  },
  computed: {
    /**
     * 계정이 ADMIN인지 여부를 확인하는 플래그
     * @author yelim
     * @return {Boolean}
     */
    isAdmin() {
      return this.userInfo.managerType === 'ADMIN';
    },
    /**
     * 이전 버튼 제공 여부
     * @author Ju
     * @return {Boolean}
     */
    showPrevBtn() {
      return !isEmpty(this.kedbInfo) && !isNil(this.kedbInfo.prevSeqNumber);
    },
    /**
     * 다음 버튼 제공 여부
     * @author Ju
     * @return {Boolean}
     */
    showNextBtn() {
      return !isEmpty(this.kedbInfo) && !isNil(this.kedbInfo.nextSeqNumber);
    },
    /**
     * KEDB 상세정보 조회시 KEDB탭에서 접근한 경우인지 확인하는 플래그
     * @author yelim
     * @return {Boolean}
     */
    isTagList() {
      return !isEmpty(this.viewType) && this.viewType === 'relationKedbPopup';
    },
    ...mapGetters(['userInfo']),
  },
  watch: {
    params: {
      immediate: true,
      handler(val) {
        if (!isEmpty(val) && has(val, 'seqNumber')) {
          this.kedbTableParams = has(val, 'tableParams') && !isEmpty(val.tableParams) ? val.tableParams : null;
          this.kedbSeqNumber = val.seqNumber;
        } else {
          this.kedbTableParams = null;
          this.kedbSeqNumber = null;
        }
      },
    },
    kedbSeqNumber: {
      immediate: true,
      handler(val) {
        if (!isNil(val)) {
          this.loadData();
        }
      },
    },
  },
  methods: {
    /**
     * KEDB 상세화면 조회에서 KEDB 목록 조회 화면으로 화면 전환
     * @author yelim
     */
    changeKedbListView() {
      this.settingInfo = {};
      this.$emit('click-change-kedb-view');
    },
    /**
     * KEDB 수정 팝업을 오픈한다.
     * @author yelim
     */
    editKedbInfo() {
      this.settingInfo = {
        kedbAttachInfo: this.kedbAttachInfo,
        kedbInfo: this.kedbInfo,
        kedbRscInfo: this.kedbRscInfo,
        kedbTroubleTicketInfo: this.relationTroubleList,
      };
      this.$refs.kedbEditPopup.open();
    },
    /**
     * KEDB 상세 정보를 조회한다.
     * @author yelim
     */
    loadData() {
      let params;
      if (isEmpty(this.kedbTableParams)) {
        params = { seqNumber: this.kedbSeqNumber };
      } else {
        params = {
          ...this.kedbTableParams,
          seqNumber: this.kedbSeqNumber,
        };
      }
      this.isLoading = true;
      KedbAPI.getKedbDetailInfo(params).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          // 전체 데이터 셋팅
          this.errorSymptomRaw = result.kedbInfo.errorSymptomRaw;
          this.errorSolutionRaw = result.kedbInfo.errorSolutionRaw;
          // 장애티켓 정보, 연관 자원, 첨부파일 항목 셋팅
          this.kedbInfo = result.kedbInfo;
          this.relationTroubleList = result.kedbTroubleTicketInfo;
          this.kedbRscInfo = result.kedbRscInfo;
          this.kedbAttachInfo = result.kedbAttachInfo;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'KEDB 상세정보', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'KEDB 상세정보', false));
        throw new Error(e);
      }).finally(() => {
        this.isLoading = false;
      });
    },
    /**
     * Date formatter
     * @author yelim
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      } else if (isNil(value) && isNil(column) && !isNil(row)) {
        return getDateToString(row);
      }
      return EMPTY_TEXT;
    },
    /**
     * KEDB에 첨부된 첨부파일을 다운로드 받는다.
     * @author yelim
     */
    downloadAttachFile(item) {
      const params = {
        attachFilename: item.attachFilename,
        seqNumber: item.seqNumber,
      };
      KedbAPI.downloadAttachFile(params);
    },
    /**
     * KEDB에 연관자원이 설정되어 있는 경우, 하단의 태그를 선택하여 태그 기준으로 KEDB 목록을 필터링 할수있다.
     * @author yelim
     */
    applyKedbFilter(item) {
      this.$emit('click-change-kedb-view', item);
    },
    /**
     * KEDB 상세 조회 화면에서 추천버튼을 클릭하는 경우
     * @author yelim
     */
    clickThumbsUpBtn() {
      const params = {
        seqNumber: this.kedbSeqNumber,
      };
      KedbAPI.updateKedbRecommend(params).then((response) => {
        const result = response.data;
        if (result) {
          if (result.success) {
            this.$message(msgUtil.getCustomResultMsgData('KEDB를 추천하였습니다.', true));
            this.kedbInfo.recommendCount = this.kedbInfo.recommendCount + 1;
          } else {
            this.$message(msgUtil.getCustomResultMsgData('KEDB 추천에 실패하였습니다.', false));
          }
        } else {
          this.$message(msgUtil.getCustomResultMsgData('KEDB 추천에 실패하였습니다.', false));
        }
      });
    },
    /**
     * 이전 KEDB 상세 정보를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    clickPrevButton() {
      this.kedbSeqNumber = this.kedbInfo.prevSeqNumber;
    },
    /**
     * 다음 KEDB 상세 정보를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    clickNextButton() {
      this.kedbSeqNumber = this.kedbInfo.nextSeqNumber;
    },
    /**
     * 장애 티켓 타이틀을 클릭 이벤트 핸들러
     * @author yelim
     * @param  {[type]} troubleTicketGroupId [description]
     */
    clickTroubleTicketGroupId(troubleTicketGroupId) {
      this.troubleTicketInfo = { troubleTicketGroupId };
      this.$refs.statusPop.open();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/event/kedb/components/KedbDetailView.vue